module.exports = __webpack_public_path__ + "img/Tessellate52.92fedca4.jpg";